import Dashboard from "../SuperAdmin/Dashboard/Dashboard";
import AdminDashboard from "../Admin/AdminDashboard/AdminDashboard";
import GenerateQRCode from "../GenerateQRCode/GenerateQRCode";
import EditQrCode from "../EditQrCode/EditQrCode";
import QRCodes from "../SuperAdmin/QRCodes/QRCodes";
import ListAdmins from "../SuperAdmin/ListAdmins/ListAdmins";
import ListSubusers from "../SuperAdmin/ListSubusers/ListSubusers";
import MyAdminQr from "../Admin/MyQr/MyQr";
import MySuperQr from "../SuperAdmin/MyQr/MyQr";
import MySubQr from "../Subuser/MyQr/MyQr";
import MyWhiteQr from "../WhiteLabelAdmin/MyQr/MyQr";

import SuperListLeadGenerations from "../SuperAdmin/LeadGeneration/ListLeadGeneration";
import SubListLeadGenerations from "../Admin/LeadGeneration/ListLeadGeneration";
import ListLeadGenerations from "../Subuser/LeadGeneration/ListLeadGeneration";
import {
  SUPER_ADMIN,
  ADMIN,
  SUB_ADMIN,
  ACTING_ADMIN,
  EDITOR_ADMIN,
  VIWEER_ADMIN,
  SUPER_ADMIN_EDITOR,
  DEVELOPER,
  WHITE_LABEL_ADMIN,
} from "../../config/roles";
import AdminDetail from "../SuperAdmin/AdminDetail/AdminDetail";
import UpgradeToPremium from "../UpgradeToPremium/UpgradeToPremium";
import TeamCollab from "../Admin/TeamCollab/TeamCollab";
import SuperTeamCollab from "../SuperAdmin/TeamCollab/SuperTeamCollab";
const routes = [
  {
    path: "/app",
    name: "Dashboard",
    component: Dashboard,
    exact: true,
    strict: true,
    role: [SUPER_ADMIN, SUPER_ADMIN_EDITOR],
  },
  {
    path: "/app/admins",
    name: "Admins",
    component: ListAdmins,
    exact: true,
    strict: true,
    role: [SUPER_ADMIN, SUPER_ADMIN_EDITOR, DEVELOPER],
  },
  {
    path: "/app/admin-detail/:id",
    name: "Add Admins",
    component: AdminDetail,
    exact: true,
    strict: true,
    role: [SUPER_ADMIN, SUPER_ADMIN_EDITOR, DEVELOPER],
  },
  {
    path: "/app/subusers",
    name: "Sub users",
    component: ListSubusers,
    exact: true,
    strict: true,
    role: [SUPER_ADMIN, SUPER_ADMIN_EDITOR, DEVELOPER],
  },

  {
    path: "/app/all-wave-cards",
    name: "All Wave Cards",
    component: QRCodes,
    exact: true,
    strict: true,
    role: [SUPER_ADMIN, SUPER_ADMIN_EDITOR, DEVELOPER],
  },
  {
    path: "/app/wave-cards",
    name: "Wave Cards",
    component: MySuperQr,
    exact: true,
    strict: true,
    role: [SUPER_ADMIN, SUPER_ADMIN_EDITOR, DEVELOPER],
  },
  {
    path: "/app/create-wave-card",
    name: "Create Wave Card",
    component: GenerateQRCode,
    exact: true,
    strict: true,
    role: [
      SUPER_ADMIN,
      SUPER_ADMIN_EDITOR,
      DEVELOPER,
      ADMIN,
      SUPER_ADMIN,
      ACTING_ADMIN,
    ],
  },
  {
    path: "/app/edit-wave-card/:id",
    name: "Edit Wave Card",
    component: EditQrCode,
    exact: true,
    strict: true,
    role: [
      SUPER_ADMIN,
      SUPER_ADMIN_EDITOR,
      DEVELOPER,
      ADMIN,
      ACTING_ADMIN,
      EDITOR_ADMIN,
      WHITE_LABEL_ADMIN,
      SUB_ADMIN,
    ],
  },
  {
    path: "/app",
    name: "Dashboard",
    component: AdminDashboard,
    exact: true,
    strict: true,
    role: [ADMIN, ACTING_ADMIN, EDITOR_ADMIN, VIWEER_ADMIN],
  },
  // {
  //   path: "/app",
  //   name: "Dashboard",
  //   component: SubAdminDashboard,
  //   exact: true,
  //   strict: true,
  //   role: [SUB_ADMIN],
  // },

  {
    path: "/app/wave-cards",
    name: "My Wave Card",
    component: MyAdminQr,
    exact: true,
    strict: true,
    role: [ADMIN, ACTING_ADMIN, EDITOR_ADMIN, VIWEER_ADMIN],
  },
  // {
  //   path: "/app/my-users-cards",
  //   name: "My Wave Cards",
  //   component: MyAdminSubQr,
  //   exact: true,
  //   strict: true,
  //   role: [ADMIN],
  // },
  // {
  //   path: "/app/subuser",
  //   name: "My Users",
  //   component: ListAdminSubusers,
  //   exact: true,
  //   strict: true,
  //   role: [ADMIN],
  // },
  {
    path: "/app/wave-cards",
    name: "Wave Cards",
    component: MySubQr,
    exact: true,
    strict: true,
    role: [SUB_ADMIN],
  },
  {
    path: "/app/lead-generation",
    name: "LeadGeneration",
    component: SuperListLeadGenerations,
    exact: true,
    strict: true,
    role: [SUPER_ADMIN, SUPER_ADMIN_EDITOR, DEVELOPER],
  },
  {
    path: "/app/lead-generation",
    name: "LeadGeneration",
    component: SubListLeadGenerations,
    exact: true,
    strict: true,
    role: [ADMIN, ACTING_ADMIN, EDITOR_ADMIN, VIWEER_ADMIN],
  },
  {
    path: "/app/lead-generation",
    name: "LeadGeneration",
    component: ListLeadGenerations,
    exact: true,
    strict: true,
    role: [SUB_ADMIN],
  },
  {
    path: "/app/subscriptions-and-plans",
    name: "UpgradeToPremium",
    component: UpgradeToPremium,
    exact: true,
    strict: true,
    role: [ADMIN, ACTING_ADMIN],
  },
  {
    path: "/app/team-collaboration",
    name: "TeamCollab",
    component: TeamCollab,
    exact: true,
    strict: true,
    role: [ADMIN],
  },
  {
    path: "/app/team-collaboration",
    name: "TeamCollab",
    component: SuperTeamCollab,
    exact: true,
    strict: true,
    role: [SUPER_ADMIN],
  },
  {
    path: "/app/my-cards",
    name: "My Card",
    component: MyWhiteQr,
    exact: true,
    strict: true,
    role: [WHITE_LABEL_ADMIN],
  },
  {
    path: "/app/edit-card/:id",
    name: "Edit Card",
    component: EditQrCode,
    exact: true,
    strict: true,
    role: [WHITE_LABEL_ADMIN],
  },
];

export default routes;
